export default __webpack_public_path__ + "static/media/Straight.47b6797e.mp3";